import { VStack, HStack } from "@/shared/ui/primitives";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";

export const FutureSection = () => {
	const { t } = useTranslation();

	const goals = [1, 2, 3];

	return (
		<motion.div
			className="w-full flex"
			initial={{ opacity: 0, y: 50 }}
			whileInView={{ opacity: 1, y: 0 }}
			viewport={{ once: true }}
			transition={{ duration: 0.6 }}
		>
			<VStack className="w-full gap-[32px] p-[24px] md:p-[48px] rounded-[20px] bg-gradient-to-r from-pm-strong to-[#FF8C5A]">
				{/* 제목 */}
				<VStack className="gap-[12px]">
					<h2 className="text-[1.5rem] md:text-[2.25rem] text-ct-elevated font-semibold text-center">
						{t("company.future.title")}
					</h2>
					<p className="text-lg text-ct-elevated font-medium text-center">
						{t("company.future.description")}
					</p>
				</VStack>

				{/* 목표 리스트 */}
				<VStack className="w-full gap-[16px]">
					{goals.map((goal, index) => (
						<motion.div
							key={index}
							className="w-full flex"
							initial={{ opacity: 0, x: -20 }}
							whileInView={{ opacity: 1, x: 0 }}
							viewport={{ once: true }}
							transition={{ delay: index * 0.15, duration: 0.5 }}
						>
							<HStack className="gap-[16px] p-[24px] rounded-[12px] bg-white/10 w-full">
								<div className="flex items-center justify-center w-[32px] h-[32px] rounded-full bg-ct-elevated flex-shrink-0">
									<span className="text-md text-pm-strong font-semibold">{index + 1}</span>
								</div>
								<p className="flex-1 text-lg text-ct-elevated font-medium">
									{t(`company.future.goal${goal}`)}
								</p>
							</HStack>
						</motion.div>
					))}
				</VStack>
			</VStack>
		</motion.div>
	);
};
